// extracted by mini-css-extract-plugin
export default {"menuDrawer":"Menu_menuDrawer__lyFB8","menuActions":"Menu_menuActions__BenWl","menuNavlink":"Menu_menuNavlink__neSqe"};